import { InteractionEvent, Sprite, Text } from 'pixi.js';
import { Game, Scene, TextureFactory } from '../core';
import { LoadingProgressBar } from '../ui';

class LoadingScene extends Scene {
  public loadingText: Text;
  public loadedContentText: Text;
  public loadingProgress: LoadingProgressBar;

  constructor(game: Game) {
    super(game);

    this.camera.setOffset({ x: 0, y: 0 });
    this.camera.setTargetPosition({ x: 540, y: 960 }, true);

    const sprite = new Sprite(TextureFactory.instance.getSingleTexture('/textures/bg/bg_loading.png'));
    this.stage.addChild(sprite);

    this.loadingText = new Text('Loading', {
      fontSize: 100,
      fill: 0xffffff,
      stroke: 0x000000,
      strokeThickness: 8,
      dropShadow: true,
      dropShadowDistance: 10,
      fontWeight: '700',
      fontFamily: 'ff-providence-sans-web-pro, sans-serif',
      fontStyle: 'normal',
      letterSpacing: -2,
      padding: 10,
    });
    this.loadingText.anchor.set(0.5);
    this.loadingText.x = 540;
    this.loadingText.y = 900;
    this.stage.addChild(this.loadingText);

    this.loadingProgress = new LoadingProgressBar(0, 1);
    this.loadingProgress.x = 540;
    this.stage.addChild(this.loadingProgress);

    this.loadedContentText = new Text('', {
      fontSize: 24,
      fill: 0xffffff,
      stroke: 0x000000,
      strokeThickness: 4,
      dropShadow: true,
      dropShadowDistance: 4,
      fontWeight: '700',
      fontFamily: 'ff-providence-sans-web-pro, sans-serif',
      fontStyle: 'normal',
      padding: 4,
    });
    this.loadedContentText.anchor.set(0.5);
    this.loadedContentText.x = 540;
    this.stage.addChild(this.loadedContentText);
  }

  public update(elapsed: number): void {
    super.update(elapsed);

    if (this.game.loaded && this.game.lastLoaded) {
      this.loadedContentText.text = `${this.game.lastLoaded} - ${(
        (this.game.loaded / this.game.maxLoaded) *
        100
      ).toFixed(2)}% (${this.game.loaded}/${this.game.maxLoaded})`;
    }
    this.loadingProgress.update(this.game.loaded, this.game.maxLoaded);
    this.loadedContentText.y = 960 + this.game.height / this.camera.zoom / 2 - 50;
    this.loadingProgress.y = 960 + this.game.height / this.camera.zoom / 2 - 20;
  }

  public destroy(): void {
    super.destroy();
  }

  public static preload = async (): Promise<void> => {};

  protected pointerdown = (event: InteractionEvent) => {};

  protected pointermove = (event: InteractionEvent) => {};

  protected pointerup = (event: InteractionEvent) => {};
}

export default LoadingScene;
